export const BASE_URL = "https://group-policy.theblackswan.in";
export const FOUNDATION_URL = "https://foundation.theblackswan.in";
export const CMS_URL = "https://cms.theblackswan.in";
export const LMS_URL = "https://lms-v2.zopper.com/lms/v1"
export const CLIENT_ID = "l7cVx73g8eefraI2"
export const CLIENT_SECRET = "Y5qpQfdzWSMGddQXipQn"


